(function () {
    'use strict';

    angular.module('notes')
        .controller('NotesController', [
            '$scope',
            'NotesService',
            'DataService',
            function ($scope, NotesService, DataService) {
                $scope.notesType = DataService.getNotesType();
                $scope.noteType = NotesService.getKTTITypeId($scope.notesType);

                $scope.noteText = null;

                $scope.saveNote = function () {
                    var obj = {
                        tipasId: $scope.noteType,
                        tekstas: $scope.noteText,
                        kelioPrieziurosObjektoId: NotesService.obj.id
                    };
                    NotesService.save(obj);
                    NotesService.obj.pastabuKiekis++;
                    $scope.noteText = null;
                    $scope.$broadcast('reloadNotes');
                };
            }]);

})();
